export type TravelNoteWallet = {
  id: number;
  items: { id: number }[];
};

export function validTravelNoteItemId(items: { id: number }[], selectedItemId: number | null): number | null {
  return selectedItemId !== null && items.some((item) => item.id === selectedItemId)
    ? selectedItemId : null;
}

function positiveId(value: string | null): number | null {
  if (!value || !/^[1-9]\d*$/.test(value)) return null;
  const id = Number(value);
  return Number.isSafeInteger(id) ? id : null;
}

export function resolveTravelNoteTarget<T extends TravelNoteWallet>(
  wallets: T[],
  search: string,
): { walletId: number | null; itemId: number | null } {
  const params = new URLSearchParams(search);
  const requestedWalletId = positiveId(params.get('walletId'));
  const requestedItemId = positiveId(params.get('itemId'));
  const wallet = requestedWalletId
    ? wallets.find((candidate) => candidate.id === requestedWalletId)
    : requestedItemId
      ? wallets.find((candidate) => candidate.items.some((item) => item.id === requestedItemId))
      : wallets.length === 1 ? wallets[0] : undefined;
  if (!wallet) return { walletId: null, itemId: null };
  return {
    walletId: wallet.id,
    itemId: validTravelNoteItemId(wallet.items, requestedItemId),
  };
}
